(function () {
  function initForiaProductCartForms(root) {
    var scope = root || document;
    var forms = Array.prototype.slice.call(scope.querySelectorAll('.foria-product-detail__form'));
    var cartDrawer = document.querySelector('cart-drawer');

    if (!forms.length) {
      return;
    }

    forms.forEach(function (form) {
      if (form.dataset.foriaAjaxCartReady === 'true') {
        return;
      }

      form.dataset.foriaAjaxCartReady = 'true';

      var button = form.querySelector('[type="submit"]');
      var message = form.querySelector('[data-foria-cart-message]');
      var variantSelect = form.querySelector('select[name="id"]');
      var quantityInput = form.querySelector('input[name="quantity"]');
      var productRoot = form.closest('.foria-product-detail') || document;
      var price = productRoot.querySelector('[data-foria-variant-price]');
      var compareAtPrice = productRoot.querySelector('[data-foria-variant-compare-price]');
      var canUseAjax = cartDrawer && window.routes && window.routes.cart_add_url;

      function selectedVariantOption() {
        if (!variantSelect || variantSelect.selectedIndex < 0) {
          return null;
        }

        return variantSelect.options[variantSelect.selectedIndex];
      }

      function syncQuantityRules() {
        var option = selectedVariantOption();

        if (!option || !quantityInput) {
          return;
        }

        var min = parseInt(option.dataset.quantityMin, 10) || 1;
        var step = parseInt(option.dataset.quantityStep, 10) || 1;
        var max = option.dataset.quantityMax ? parseInt(option.dataset.quantityMax, 10) : null;

        quantityInput.min = min;
        quantityInput.dataset.min = min;
        quantityInput.step = step;

        if (max) {
          quantityInput.max = max;
          quantityInput.dataset.max = max;
        } else {
          quantityInput.removeAttribute('max');
          delete quantityInput.dataset.max;
        }

        quantityInput.value = min;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        var plusButton = form.querySelector('.foria-product-detail__quantity-control [name="plus"]');
        if (plusButton && !max) {
          plusButton.classList.remove('disabled');
        }
      }

      function syncVariantDetails(updateUrl) {
        var option = selectedVariantOption();

        if (!option) {
          return;
        }

        var available = option.dataset.available === 'true';

        if (price) {
          price.textContent = option.dataset.price || '';
        }

        if (compareAtPrice) {
          compareAtPrice.textContent = option.dataset.compareAtPrice || '';
          compareAtPrice.hidden = !option.dataset.compareAtPrice;
        }
        
        var units = parseInt(option.dataset.unitsPerPack, 10);
        if (units) {
          productRoot.querySelectorAll('[data-foria-mix-count]').forEach(function (el) {
            el.textContent = Math.round(units / 3) + ' botellas';
          });
        }

        if (button) {
          button.disabled = !available;
          button.textContent = available ? 'Comprar' : 'Agotada';
          button.dataset.originalText = button.textContent;
        }

        syncQuantityRules();

        if (updateUrl && option.dataset.variantUrl && window.history && window.history.replaceState) {
          window.history.replaceState({}, '', option.dataset.variantUrl);
        }
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          syncVariantDetails(true);
        });

        syncVariantDetails(false);
      }

      if (!canUseAjax) {
        return;
      }

      if (!message) {
        message = document.createElement('p');
        message.className = 'foria-product-detail__form-message';
        message.setAttribute('data-foria-cart-message', '');
        message.setAttribute('role', 'status');
        message.hidden = true;
        form.appendChild(message);
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        var config = window.fetchConfig
          ? window.fetchConfig('javascript')
          : {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
            };
        var formData = new FormData(form);

        if (config.headers) {
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
        }

        if (cartDrawer.getSectionsToRender) {
          formData.append(
            'sections',
            cartDrawer
              .getSectionsToRender()
              .map(function (section) {
                return section.id;
              })
              .join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        button.dataset.originalText = button.dataset.originalText || button.textContent;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');
        button.textContent = 'Añadiendo';
        message.hidden = true;
        message.textContent = '';

        if (cartDrawer.setActiveElement) {
          cartDrawer.setActiveElement(button);
        }

        fetch(window.routes.cart_add_url, config)
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            if (response.status) {
              throw new Error(response.description || response.message || 'No se ha podido añadir al carrito.');
            }

            cartDrawer.classList.remove('is-empty');

            if (cartDrawer.renderContents && response.sections) {
              cartDrawer.renderContents(response);
            } else if (cartDrawer.open) {
              cartDrawer.open(button);
            }

            button.textContent = 'Añadido';
            window.setTimeout(function () {
              button.textContent = button.dataset.originalText;
            }, 1200);
          })
          .catch(function (error) {
            message.textContent = error.message || 'No se ha podido añadir al carrito.';
            message.hidden = false;
            button.textContent = button.dataset.originalText;
          })
          .finally(function () {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-disabled');
          });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForiaProductCartForms);
  } else {
    initForiaProductCartForms();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initForiaProductCartForms(event.target);
  });
})();
